import { OrdersSyncStatus, OrdersSyncStatusResponse } from '@api-ui-app/src/app/orders/lib/orders-sync-status-response';

export const isSyncOrdersActive = (response: OrdersSyncStatusResponse) =>
  (!response?.data && !response.error?.code) || isSyncOrdersStatusActive(response.data.status);

export const isSyncOrdersStatusActive = (status: OrdersSyncStatus) => status !== OrdersSyncStatus.FINISHED;
